module.exports = __webpack_public_path__ + "img/imgCard02.dfe9d09a.jpg";